import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";

export default function Navbar() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const navLinks = [
    { name: "Home", href: "/" },
    { name: "About", href: "/about" },
    { name: "Services", href: "/services" },
    { name: "Portfolio", href: "/portfolio" },
    // { name: "Blogs", href: "/blogs" },
    { name: "Contact", href: "/contact" },
  ];

  const toggleMenu = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <header className="fixed top-0 left-0 w-full z-50 backdrop-blur-md bg-white/80 shadow-sm">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
        {/* ✅ Logo */}
        <Link to="/" className="flex items-center">
          <img
            src="/header-logo.png"
            alt="Dev Sols Logo"
            className="h-10 w-auto"
          />
        </Link>

        {/* ✅ Desktop Nav */}
        <nav className="hidden md:flex gap-6">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.href;
            return (
              <Link
                key={link.name}
                to={link.href}
                style={{ fontFamily: "Montserrat, sans-serif" }}
                className={`transition ${
                  isActive
                    ? "text-[#1b75bc] font-bold"
                    : "hover:text-[#1b75bc] font-semibold text-[#414042]"
                }`}
              >
                {link.name}
              </Link>
            );
          })}
        </nav>

        {/* ✅ Mobile Hamburger */}
        <div className="md:hidden text-2xl text-[#1b75bc]">
          <button onClick={toggleMenu}>
            {mobileOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      {/* ✅ Mobile Drawer Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white w-full px-6 pb-6 pt-2 shadow transition">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.href;
            return (
              <Link
                key={link.name}
                to={link.href}
                onClick={() => setMobileOpen(false)}
                style={{ fontFamily: "Montserrat, sans-serif" }}
                className={`block py-2 text-lg transition ${
                  isActive
                    ? "text-[#1b75bc] font-bold"
                    : "hover:text-[#1b75bc] text-[#414042] font-medium"
                }`}
              >
                {link.name}
              </Link>
            );
          })}
        </div>
      )}
    </header>
  );
}